module.exports = global["$"] = require("-!/Users/jin/Documents/github/vue2-admin-lte/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 403
// module chunks = 0